function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9497 8.46455C17.3403 8.07402 17.3403 7.44086 16.9497 7.05033C16.5592 6.65981 15.9261 6.65981 15.5355 7.05033L12 10.5859L8.46447 7.05033C8.07394 6.65981 7.44078 6.65981 7.05025 7.05033C6.65973 7.44086 6.65973 8.07402 7.05025 8.46455L10.5858 12.0001L7.05025 15.5356C6.65973 15.9261 6.65973 16.5593 7.05025 16.9498C7.44078 17.3404 8.07394 17.3404 8.46447 16.9498L12 13.4143L15.5355 16.9498C15.9261 17.3404 16.5592 17.3404 16.9497 16.9498C17.3403 16.5593 17.3403 15.9261 16.9497 15.5356L13.4142 12.0001L16.9497 8.46455Z",
  fill: "#999999"
});

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.c72c97ea.svg";
export { ForwardRef as ReactComponent };